var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcheckbluebold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.884 5.88398L7.50009 16.2679L2.11621 10.884L3.88398 9.11621L7.50009 12.7323L16.1162 4.11621L17.884 5.88398Z",
    fill: "#1271FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcheckbluebold);
export default __webpack_public_path__ + "static/media/icon.check.blue.bold.035919e317be8f4025b0b35ba3fa1e6e.svg";
export { ForwardRef as ReactComponent };